import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ModalController, ToastController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UserProvider } from 'src/app/services/user/user';
import { BuscarPessoaPage } from '../../buscar-pessoa/buscar-pessoa.page';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { OracaoProvider } from 'src/app/services/oracao/oracao';
import { CommonModule } from '@angular/common';
import { ImagePipe } from 'src/app/pipes/image/image';
import { NomenclaturaService } from 'src/app/services/nomenclatura/nomenclatura';

@Component({
  selector: 'app-oracao-adm-add',
  templateUrl: './oracao-adm-add.page.html',
  styleUrls: ['./oracao-adm-add.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    ReactiveFormsModule,
    NomenclaturaPipe
  ],
})
export class OracaoAdmAddPage implements OnInit {
  idOracao: any;
  pessoa: any = {};
  publico: boolean = false;
  validations_form: FormGroup;
  nomenclaturaDesc: string = "";
  tipos: any;
  tipoNomenclatura: string = '0';
  nomenclaturaTestemunho: any;
  isSubmitting = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder,
    public oracaoProvider: OracaoProvider,
    public toastCtrl: ToastController,
    private nomenclatura: NomenclaturaService,
    private translate: TranslateService,
    public userProvider: UserProvider,
  ) {

    this.tipoNomenclatura = this.navParams.get('tipo');
    var data = this.navParams.get('pedido');

    this.nomenclaturaTestemunho = this.nomenclatura.configProvider.instituicao.nomenclatura.testemunho;
    this.nomenclaturaDesc = this.nomenclatura.configProvider.instituicao.nomenclatura.oracao;

    if (this.tipoNomenclatura == '2') {
      this.tipos = [{ 'id': 2, nome: this.nomenclaturaTestemunho }];

    } else if (this.tipoNomenclatura == '1') {
      this.tipos = [{ 'id': 1, nome: this.translate.instant('Pedido de ') + this.nomenclaturaDesc }];

    } else {
      this.tipos = [{ 'id': 1, nome: this.translate.instant('Pedido de ') + this.nomenclaturaDesc }, { 'id': 2, nome: this.nomenclaturaTestemunho }];
    }

    if (data && data.id) {
      this.pessoa = data.pessoa;
      this.pessoa.id = data.idPessoa;
      this.publico = data.privacidade == 'PUBLICO';
      this.validations_form = this.formBuilder.group({
        pedido: new FormControl(data.pedido, Validators.required),
        publico: new FormControl(data.privacidade == 'PUBLICO'),
        tipo: new FormControl(data.isTestemunho == '0' ? 1 : 2, Validators.required),
      });
    } else {
      this.validations_form = this.formBuilder.group({
        pedido: new FormControl('', Validators.required),
        publico: new FormControl(false),
        tipo: new FormControl(1, Validators.required),
      });
    }
  }

  ngOnInit() {
  }

  validation_messages = {
    'pedido': [
      { type: 'required', message: this.translate.instant('Campo obrigatório') }
    ],
    'tipo': [
      { type: 'required', message: this.translate.instant('Campo obrigatório') }
    ]
  };

  getNomenclatura(tipoNomenclatura: string) {
    return tipoNomenclatura == '2' ? 'testemunho' : 'oracao';
  }

  async selecionarPessoa() {
    var dataPessoa = { 'isVisitante': false, 'flagOracao': true };
    var modalPessoa = await this.modalCtrl.create({ component: BuscarPessoaPage, componentProps: dataPessoa });
    modalPessoa.present();

    const { data } = await modalPessoa.onWillDismiss()
    if (data) {
      this.pessoa = data.pessoa;
    }

  }

  onSubmit(oracao: { pedido: any; publico: boolean | undefined; tipo: number; }) {
    this.isSubmitting = true;
    this.oracaoProvider.criarOracao(oracao.pedido, oracao.publico, 0, (oracao.tipo == 2 ? '1' : '0'), this.pessoa.id).subscribe(async data => {
      let message = this.nomenclaturaDesc + this.translate.instant(' cadastrada com sucesso!');
      if (oracao.tipo == 2) {
        message = this.nomenclaturaTestemunho + this.translate.instant(' cadastrada com sucesso!');
      }

      const toast = await this.toastCtrl.create({
        message: message,
        duration: 3000
      });

      toast.present();

      this.modalCtrl.dismiss(true);
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
